<template>
  <font-awesome-icon
    :icon="`fa-${type} fa-${name}`"
    :class="`icon far fa-${name}`"
    :style="{ color: cor }"
    teste
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SolutiIcon',
    props: {
      name: {
        type: String,
        default: 'question',
      },
      fixWidth: Boolean,
      blink: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
      },
      colorVariation: {
        type: String,
        default: '500',
      },
      type: {
        type: String,
        default: 'regular',
      },
    },
    data: () => ({
      value: '',
      url: '',
    }),
    computed: {
      cor() {
        return this.color
          ? `var(--color-${this.color}-${this.colorVariation})`
          : ''
      },
    },
  })
</script>

<style lang="stylus">
  .icon
    svg
      height: 1rem
      width: 1rem
      fill: currentColor
  @keyframes icon-blink
    0%
      opacity: 1
    50%
      opacity: .6
    100%
      opacity: .2
  .blink
    -webkit-animation: icon-blink .9s linear infinite
    -moz-animation: icon-blink .9s linear infinite
    -ms-animation: icon-blink .9s linear infinite
    -o-animation: icon-blink .9s linear infinite
    animation: icon-blink .9s linear infinite
</style>
